import { IMAGE_SIZE } from '@/src/elements/image/image.constants'
import type { TUserAvatar } from '@/src/features/user/models/User'

import { getImageUrl } from './getImageUrl'

export const getAvatarUrl = (
  avatar?: TUserAvatar | null,
  size: (typeof IMAGE_SIZE.AVATAR)[keyof typeof IMAGE_SIZE.AVATAR] = IMAGE_SIZE.AVATAR.TINY,
): string => {
  if (size === IMAGE_SIZE.AVATAR.BIG && avatar?.picture && typeof avatar?.picture === 'object') {
    return getImageUrl({ id: avatar.picture.id }, size)
  }
  return avatar?.icon ? getImageUrl({ id: avatar.icon.id }, size) : require('@/img/hozana_img_avatar_default.png')
}
